import { getUserId } from '../../contexts/UserDataContext'
import getConfig from '../../Helpers/getConfig'
import { getFlowId } from '../../Helpers'

const getBannersCategoryClient = async (categories, tenant) => {
  const baseURLbff = getConfig('baseURLbff')
  const cat = encodeURIComponent(categories)
  const baseUrl = encodeURIComponent('https://www.lider.cl/catalogo/category/')
  const url = `${baseUrl}${cat}`
  const categoryFromBffResponse = await fetch(
    `${baseURLbff}banners/category?category=${cat}&tenant=${tenant}&url=${url}`,
    {
      method: 'GET',
      headers: {
        tenant,
        'X-SessionId': getUserId(),
        'X-FlowId': getFlowId(),
      },
    }
  )
  const categoryConfig = await categoryFromBffResponse.json()
  return categoryConfig
}

export default getBannersCategoryClient
